// bootstrap-component.js
import { Tooltip, Modal, Toast , Offcanvas } from 'bootstrap';

export default class bootstrapcomponent {
    constructor() { }

    tooltip() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
    }


    // Show a specific modal by ID
    showModal(modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        } else {
            console.error(`Modal with ID "${modalId}" not found.`);
        }
    }

    // Close a specific modal by ID
    closeModal(modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
            modal.hide();
        } else {
            console.error(`Modal with ID "${modalId}" not found.`);
        }
    }

    // Show a toast message by ID with custom content and auto-hide after 5 seconds
    showToast(toastId, message) {
        const toastElement = document.getElementById(toastId);
        const toastMessageElement = document.getElementById('toastMessage');  // Get the element for the message

        if (toastElement && toastMessageElement) {
            toastMessageElement.innerHTML = message;  // Set the custom message
            const toast = new Toast(toastElement);
            toast.show();

            // Automatically hide the toast after 5 seconds
            setTimeout(() => {
                toast.hide();
            }, 5000); // Adjust the time as needed
        } else {
            console.error(`Toast with ID "${toastId}" or message element not found.`);
        }
    }


    // Hide a toast message by ID
    hideToast(toastId) {
        const toastElement = document.getElementById(toastId);
        if (toastElement) {
            const toast = Toast.getInstance(toastElement);
            if (toast) {
                toast.hide();
            }
        } else {
            console.error(`Toast with ID "${toastId}" not found.`);
        }
    }

     // Show a specific offcanvas by ID
     showOffcanvas(offcanvasId) {
        const offcanvasElement = document.getElementById(offcanvasId);
        if (offcanvasElement) {
            const offcanvas = new Offcanvas(offcanvasElement);
            offcanvas.show();
        } else {
            console.error(`Offcanvas with ID "${offcanvasId}" not found.`);
        }
    }

    // Hide a specific offcanvas by ID
    hideOffcanvas(offcanvasId) {
        const offcanvasElement = document.getElementById(offcanvasId);
        if (offcanvasElement) {
            const offcanvas = Offcanvas.getInstance(offcanvasElement);
            if (offcanvas) {
                offcanvas.hide();
            }
        } else {
            console.error(`Offcanvas with ID "${offcanvasId}" not found.`);
        }
    }

    // Close any visible offcanvas
    closeVisibleOffcanvas(selector) {
        const visibleOffcanvas = document.querySelector(selector);
        if (visibleOffcanvas) {
            const offcanvas = Offcanvas.getInstance(visibleOffcanvas);
            if (offcanvas) {
                offcanvas.hide();
            }
        }
    }
}
